import { CollapsableSidebarRoot, VIEW_SELECTOR_FULL_WIDTH, VIEW_SELECTOR_COLLAPSED_WIDTH, VIEW_SELECTOR_BREAK_POINT } from 'svh-workspace-ui-lib/collapsable-sidebar/public';
import ViewSelectorSidebarSkeletonState from './ViewSelectorSidebarSkeletonState';
import InboxNavigationSidebar from '../../navigation-sidebar/components/InboxNavigationSidebar';
import { useViews } from 'find-and-filter-data/views-data/public';
import { useSelector } from 'react-redux';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import FatalError from 'conversations-error-reporting/error-boundaries/components/FatalError';
import { jsx as _jsx } from "react/jsx-runtime";
function viewSelectorIsLocked() {
  return window.innerWidth > VIEW_SELECTOR_BREAK_POINT;
}
export default function ViewSelectorSidebar() {
  const inboxId = useSelector(getCurrentInboxId);
  const {
    isLoading,
    hasFailed
  } = useViews(inboxId);
  if (hasFailed) {
    return /*#__PURE__*/_jsx(FatalError, {});
  }
  if (!inboxId || isLoading) {
    return /*#__PURE__*/_jsx(ViewSelectorSidebarSkeletonState, {});
  }
  return /*#__PURE__*/_jsx(CollapsableSidebarRoot, {
    collapsedWidth: VIEW_SELECTOR_COLLAPSED_WIDTH,
    defaultLocked: viewSelectorIsLocked(),
    errorLoggingTitle: "ViewSelectorSidebar",
    fullWidth: VIEW_SELECTOR_FULL_WIDTH,
    collapseButtonPosition: {
      topOffset: 6,
      alignment: 'left'
    },
    children: /*#__PURE__*/_jsx(InboxNavigationSidebar, {})
  });
}
ViewSelectorSidebar.displayName = 'ViewSelectorSidebar';